import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkTimeService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/worktime`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/worktime/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/worktime/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/worktime`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/worktime/`+Id);
    }

}
